// Marks the nav anchor of the section in view (#508). Without
// IntersectionObserver the anchors still work, just unmarked.
const anchors = [
  ...document.querySelectorAll<HTMLAnchorElement>("a[data-nav-anchor]"),
];
const sections = anchors
  .map((a) => document.getElementById(a.hash.slice(1)))
  .filter((s): s is HTMLElement => s !== null);

function mark(id: string | null): void {
  for (const a of anchors) {
    if (a.hash === `#${id ?? ""}`) a.setAttribute("aria-current", "true");
    else a.removeAttribute("aria-current");
  }
}

if ("IntersectionObserver" in window) {
  const visible = new Set<string>();
  const observer = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (e.isIntersecting) visible.add(e.target.id);
        else visible.delete(e.target.id);
      }
      mark(sections.find((s) => visible.has(s.id))?.id ?? null);
    },
    { rootMargin: "-96px 0px -50% 0px" },
  );
  for (const s of sections) observer.observe(s);
}
